export { MarketingConsent } from './MarketingConsent';
